// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_3tyZVrFDUd3OacmKLuIEhJ","checkboxLabel":"qGh2BW0TMIstSadd0Q_NR","button":"zhIXnDZjQVjFv9AX8dMx7","error":"_2EgTTA3s7XPFG0sJU181IF","iconContainer":"zF8P_Oir9GkbNXpBSEnVL","icon":"YgHALiwEXMKxM4HRxQ57","megascans":"_13eUS4mJkJ7ftEQajyTw6D","btnContainer":"_1WByKOVaN1tws_1IfJPrxS","smBtnContainer":"_1uFTAhkXiZTRb1vqJ2hQ4g","heading":"_1FMFzB7Q18K6tPnPCQjt8U"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscriptionSubscribe.scss
// module id = 2968
// module chunks = 0